// extracted by mini-css-extract-plugin
module.exports = {"link":"AnchorLink_link__2YctX"};